"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceAuthType = void 0;
exports.SourceAuthType = {
    Oauth: "oauth",
    TeamOauth: "team_oauth",
    Sdk: "sdk",
    Password: "password",
    Email: "email",
    App: "app",
    Empty: "",
};
